import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'hooks/useAppStore';
import { PageSkeleton } from 'components/ui/Skeleton';
import { ROUTES } from 'constants/routes';

interface GuestGuardProps {
  children: React.ReactNode;
}

/** Redirects signed-in users away from guest-only pages (e.g. marketing home). */
export function GuestGuard({ children }: GuestGuardProps) {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const isLoading = useAppSelector((s) => s.auth.isLoading);

  if (isLoading && !isAuthenticated) {
    return <PageSkeleton />;
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
}
